// extracted by mini-css-extract-plugin
module.exports = {"concepts":"styles_concepts__13MbY","containerConcepts":"styles_containerConcepts__3GyEZ"};